import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classes from './classes.module.scss';
import { Navigation, Pagination, Zoom } from 'swiper/modules';
import SwiperFullScreen from './SwiperFullScreen';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/zoom';

const MediaSwiper = ({ items, getItems, itemsPerPage, navigationEnabled, fullScreenEnabled, updateTimeStamp }) => {
    const swiperRef = useRef(null);
    const [loaded, setLoaded] = useState(false);
    const [moments, setMoments] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [activeMoment, setActiveMoment] = useState(null);

    useEffect(() => {
        if (items) {
            setMoments(items);
        }
    }, [items])

    useEffect(() => {
        if (loaded) {
            return
        }

        if (getItems) {
            loadItems();
        }
    }, [loaded])

    useEffect(() => {
        if (updateTimeStamp) {
            setLoaded(false);
        }
    }, [updateTimeStamp])

    const loadItems = async () => {
        const results = await getItems(1, itemsPerPage);
        const moments = cleanItems(results);
        setMoments(moments);
        setActiveMoment(setActiveMoment(moments[0]));
        setLoaded(true);
    }

    const cleanItems = items => {
        return items && items.map(item => {
            if (item.html || item.src) {
                return item;
            }

            return {
                id: item.id,
                html: `<div style="width:90%;height:90%;margin-left:5%;background-image:url(${item.src});background-size:cover" title="${item.id}: ${item.filename}"></div>`
            }
        });
    }

    const handleSlideChange = (swiper) => {
        const { activeIndex } = swiper;
        setActiveMoment(moments[activeIndex]);
    }

    const handleShowPreview = () => {
        setShowPreview(true);
        if (!activeMoment) {
            setActiveMoment(moments[0]);
        }
    }

    fullScreenEnabled = fullScreenEnabled ? fullScreenEnabled : true;

    return <div>
        <div className={classes.appendButtons}>
            {
                activeMoment && !activeMoment.is_video &&
                (
                    <>
                        <ZoomInIcon onClick={() => swiperRef.current.swiper.zoom.in()} />
                        <ZoomOutIcon onClick={() => swiperRef.current.swiper.zoom.out()} />
                    </>
                )
            }
            {
                fullScreenEnabled &&
                <FullscreenIcon onClick={() => handleShowPreview()} />
            }
        </div>
        <Swiper
            ref={swiperRef}
            style={{
                '--swiper-navigation-color': '#fff',
                '--swiper-pagination-color': '#fff',
            }}
            slidesPerView={1}
            navigation={navigationEnabled || true}
            zoom={true}
            modules={[Navigation, Zoom]}
            className={classes.swiper}
            onSlideChange={handleSlideChange}
        >
            {
                moments && moments.map((item) => {
                    return <SwiperSlide>
                        {
                            !item.is_video ?
                                <div className="swiper-zoom-container">
                                    <img src={item.src} className={classes.slideMoment} />
                                </div> :
                                <div className='swiper-zoom-container'>
                                    <video height='100%' controls>
                                        <source src={item.src}></source>
                                    </video>
                                </div>
                        }
                    </SwiperSlide>
                })
            }
        </Swiper>
        {
            activeMoment &&
            <SwiperFullScreen open={showPreview} onClose={() => setShowPreview(false)} moment={activeMoment} />
        }
    </div>
}

export default MediaSwiper;